/* eslint-disable react/prop-types */
import React from 'react'
import IdentityContact from './IdentityContactCard'
import JobInformation from './JobInformationCard'

function UserProperties(props) {
  const { employee, intl, employeeEmailOptions = [], isIntegrated = true } = props
  const isEmailEditable = isIntegrated ? !employee?.onPremisesSyncEnabled : true

  return (
    <div className="section px-4 py-4">
      <IdentityContact employee={employee} intl={intl} isIntegrated={isIntegrated} isEmailEditable={isEmailEditable} />
      {isIntegrated ? (
        <>
          <hr className="mb-3" />
          <JobInformation employee={employee} intl={intl} employeeEmailOptions={employeeEmailOptions} />
        </>
      ) : (
        <>
          <hr className="mb-3" />
          <JobInformation
            employee={employee}
            intl={intl}
            employeeEmailOptions={employeeEmailOptions}
            showOnlyBasicFields
          />
        </>
      )}
    </div>
  )
}

export default UserProperties
